import { isProductionRelease } from ':fat/init/env';

const COLORS: Record<Entity | 'messageKind', string> = {
  mainPage: 'lightgreen',
  securityFrame: 'orange',
  blockchainWorker: 'crimson',
  databaseWorker: 'darkorchid',
  messageKind: 'deepskyblue',
};

function pretty(entity: Entity) {
  const withSpace = entity.replace(/([A-Z])/, ' $1');
  return withSpace[0].toUpperCase() + withSpace.slice(1);
}

function entityStyle(entity: Entity) {
  return `font-weight: bolder; color: ${COLORS[entity]}`;
}

function messageKindStyle() {
  return `font-weight: bolder; color: ${COLORS.messageKind}`;
}

function defaultStyle() {
  return `font-weight: initial; color: initial`;
}

function envelopeStyle() {
  return 'font-size: 20px';
}

// Useful for reducing clutter during development
const SILENT_MESSAGES: AnyValidMessage['kind'][] = [
  'PING',
  'PONG',
  'SANITY_CHECK',
  'SANITY_CHECK_RESPONSE',
];

export function logMessage(message: AnyTaggedMessage, inReplyTo?: AnyTaggedMessage) {
  if (!isProductionRelease) {
    if (SILENT_MESSAGES.includes(message.kind)) return;

    const { from, to } = message;
    const messageForLogging = inReplyTo
      ? {
          ...message,
          originalMessage: inReplyTo,
        }
      : message;

    // eslint-disable-next-line no-console
    console.log(
      `%c📨 %c${pretty(from)}%c => %c${pretty(to)}%c: %c${message.kind}%c${
        inReplyTo ? ' (reply)' : ''
      }`,
      envelopeStyle(),
      entityStyle(from),
      defaultStyle(),
      entityStyle(to),
      defaultStyle(),
      messageKindStyle(),
      defaultStyle(),
      '\n',
      messageForLogging,
    );
  }
}
